// tslint:disable:max-line-length

import React from 'react';

export const ObjectDocument = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9.5,0h-8v16h13V5h-5V0z M3.5,4h4v1h-4V4z M3.5,10h7v1h-7V10z M12.5,14h-9v-1h9V14z M12.5,7v1h-9V7H12.5z" />
    </svg>
  );
};
